import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs-make";

export default class extends Controller {
  static targets = ["sectionsList"];

  connect() {
    this.sortables = new Map();
    this.dragging = false;
    this.refresh();
    this.observer = new MutationObserver(() => this.scheduleRefresh());
    this.observe();
  }

  disconnect() {
    window.clearTimeout(this.refreshTimer);
    this.observer?.disconnect();
    this.sortables.forEach((sortable) => sortable.destroy());
    this.sortables.clear();
  }

  scheduleRefresh() {
    window.clearTimeout(this.refreshTimer);
    if (this.dragging) return;

    this.refreshTimer = window.setTimeout(() => this.refresh(), 0);
  }

  refresh() {
    if (this.dragging) return;

    const lists = new Set(this.element.querySelectorAll("[data-item-list]"));
    if (this.hasSectionsListTarget) lists.add(this.sectionsListTarget);

    this.sortables.forEach((sortable, list) => {
      if (lists.has(list)) return;
      sortable.destroy();
      this.sortables.delete(list);
    });
    lists.forEach((list) => {
      if (this.sortables.has(list)) return;
      const sections = this.hasSectionsListTarget && list === this.sectionsListTarget;
      this.sortables.set(list, Sortable.create(list, {
        animation: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 150,
        ...(sections ? { group: { name: "link-in-bio-sections", put: false } } : {}),
        handle: sections ? "[data-sortable-section-handle]" : "[data-sortable-item-handle]",
        draggable: sections ? "[data-sortable-section]" : "[data-sortable-item]",
        onMove: ({ to }) => to === list,
        onStart: () => {
          this.dragging = true;
          window.clearTimeout(this.refreshTimer);
        },
        onEnd: () => {
          this.dragging = false;
          this.dispatch("change", { bubbles: true });
          this.scheduleRefresh();
        },
      }));
    });
  }

  observe() {
    if (this.hasSectionsListTarget) {
      this.observer?.observe(this.sectionsListTarget, { childList: true, subtree: true });
    }
  }
}
